import { useContext } from 'react'

import {
  Button, FileUploadZone, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject, pascalToSnakeCase, snakeToTitleCase } from '@domain-group/javascript-utils'

import useUppyImageUpload from '@hooks/useUppyImageUpload'

import ImageList from './components/ImageList'

const MODAL_KEY = 'ManageEntityImagesModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const ManageEntityImagesModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { imageOptions } = modalPayload

  const uppy = useUppyImageUpload(
    {
      callbacks: {
        afterAction: () => {},
      },
      ...imageOptions,
      requestOptions: {
        include_image_sizes: true,
      },
    },
    [imageOptions.imageable_id],
  )

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal} size="small">
      <SidebarModal.Header
        callbacks={callbacks}
        title="Manage"
        titleSecondLine={`${snakeToTitleCase(pascalToSnakeCase(imageOptions.imageable_type))} Images`}
      />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="Upload Image">
            <FileUploadZone uppy={uppy} />
          </Form.Field>
        </Form>

        <ImageList imageOptions={imageOptions} />
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="secondaryUtility"
          onClick={() => closeModal()}
          size="large"
        >
          Close
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ManageEntityImagesModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
